import { IPeriodShort } from '@/entities';
import * as types from '@/store/types';
import { getDefaultDateRange } from '@/utils';
import { DateRangeMapper } from '@/entities';
import {Getter} from 'vuex';

interface State {
    datePeriod: IPeriodShort;
}

const initialState: State = {
    datePeriod: null
};

const getters = {
    [types.USERDATA_GET_DEFAULT_PERIOD]: (state: State) => {
        if (state.datePeriod) {
            return state.datePeriod;
        }
        return null;
    },
    [types.USERDATA_GET_ROUTER_QUERY]: (state: State, allGetters) => {
        const dateRange = allGetters[types.USERDATA_GET_DEFAULT_PERIOD];
        if (dateRange) {
            return {dateRange: DateRangeMapper.toString(dateRange)};
        }
        return null;
    }
};

const mutations = {
    [types.USERDATA_SAVE_PERIOD]: (state: State, payload: IPeriodShort) => {
        state.datePeriod = payload;
    },
    [types.USERDATA_RESET_PERIOD]: (state: State, payload: IPeriodShort) => {
        state.datePeriod = null;
    }
};

export default {
    state: initialState,
    mutations,
    getters
};
